
<template>
  <unsupported-page>
    <template v-slot:title>
      This device isn’t supported during beta - please use a Mac or PC to access the Visualizer.
    </template>
    <template v-slot:body>
      <a :href="seratoLink">Serato Home</a>
    </template>
  </unsupported-page>
</template>
<script setup lang="ts">
import UnsupportedPage from '@/components/unsupported-pages/UnsupportedPage.vue'
const seratoLink = import.meta.env.VUE_APP_CLIENT_URI_SERATO_COM
</script>
